import { $iq, Strophe } from "strophe.js";
import { StrophePlugin } from "./strophe-plugin";
import type { StropheConnection, StropheHandler } from "./types";

export class StrophePingPlugin extends StrophePlugin {
    public constructor() {
        super('ping');
    }

    public static build() { return new StrophePingPlugin(); }

    public init(conn: StropheConnection): void {
        super.init(conn);
        Strophe.addNamespace('PING', 'urn:xmpp:ping');
    }


    /**
     * Function: ping
     *
     * Parameters:
     * (String) to - The JID you want to ping
     * (Function) success - Callback function on success
     * (Function) error - Callback function on error
     * (Integer) timeout - Timeout in milliseconds
     * @param jid
     * @param success
     * @param error
     * @param timeout
     */
    public ping(jid: string, success: Function, error: Function, timeout: number) {
        const id = this.connection.getUniqueId('ping');
        const iq = $iq({ type: 'get', to: jid, id: id }).c(
            'ping', { xmlns: Strophe.NS.PING });
        this.connection.sendIQ(iq, success, error, timeout);
    }

    /**
     * Function: pong
     *
     * Parameters:
     * (Object) ping - The ping stanza from the server
     * @param ping
     */
    public pong(ping: Element) {
        const from = ping.getAttribute('from');
        const id = ping.getAttribute('id');
        const iq = $iq({ type: 'result', to: from, id: id });
        this.connection.sendIQ(iq);
    }

    /**
     * Function: addPingHandler
     * Parameters:
     * (Function) handler - Ping handler
     * Returns:
     * A reference to the handler that can be used to remove it.
     * @param handler
     */
    public addPingHandler(handler: (stanza: Element) => boolean): StropheHandler {
        return this.connection.addHandler(handler, Strophe.NS.PING, "iq", "get");
    }
}
